var _style, _path, _defs, _mask, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconUbpLight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-ubp-light_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 800 800",
    xmlSpace: "preserve",
    enableBackground: "new 0 0 800 800"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M742.7 800H57.3C25.7 800 0 774.3 0 742.7V57.3C0 25.7 25.7 0 57.3 0h685.3C774.3 0 800 25.7 800 57.3v685.3c0 31.7-25.7 57.4-57.3 57.4z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "icon-ubp-light_svg__Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: 163.8,
    y: 132.9,
    width: 472.4,
    height: 534.1
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
  })))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 163.8,
    y: 132.9,
    width: 472.4,
    height: 534.1,
    id: "icon-ubp-light_svg__mask-2_00000054224340815980466050000002212007103243664274_"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#icon-ubp-light_svg__Adobe_OpacityMaskFilter)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon-ubp-light_svg__path-1_00000142882758589673465960000009539229957194024379_",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#fff",
    d: "M163.8 667.1h2191.4V132.9H163.8z"
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "icon-ubp-light_svg__Fill-14_00000114780708092026477400000003651402716035840436_",
    d: "M503.6 414.1c-22.1-2.9-31.7-4.1-31.7-4.1v-80c5.5 1.4 41.4 10.3 41.4 10.3 22 4.4 33.2 20.7 33.2 40.2 0 19.5-17.1 37-42.9 33.6m88.6 33.1s25.5-25.8 25.5-74.3c0-40.5-26.8-85.4-74.1-102.3l-155.4-56.1-.5 274.4s0 39.7-43.5 48.1c-29.2 5.6-57.6-21.2-57.6-54.6 0 0 .2-216.2 0-304.9L163.8 133v361.2c0 129 115.1 183.6 185.7 171.2 84.4-14.9 122.4-81.2 122.4-153v-25.5l59.5 2.1c19.7 0 34.3 17.5 34.3 35.8 0 16.2-11.1 33.7-34.1 35.7L499 563c-5.2 21.9-16.6 52.2-42.1 82.4l95.8-17.2c38.6-7.1 83.5-41.2 83.5-97.5 0-24.1-8-59.2-44-83.5",
    mask: "url(#icon-ubp-light_svg__mask-2_00000054224340815980466050000002212007103243664274_)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#f7931e"
  })));
}

export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiYXNzZXRzL2ltYWdlcy9jNmJkYmEzY2JkYmYyNTc5YjdiY2YxM2ZiY2JiYzI1Mi1pY29uLXVicC1saWdodC5zdmciOw==";
export { SvgIconUbpLight as ReactComponent };